<template>
  <div class="currency-select">
    <b-dropdown
      menu-class="text-right"
      right
      variant="currency"
    >
      <template v-slot:button-content>
        {{ $t('message.currency') }}:&nbsp;<span class="mx-1">{{ currency.symbol }}</span>
      </template>
      <b-dropdown-item
        :key="cur.code" @click.prevent="selectCurrency(cur.code)"
        href="#"
        v-for="cur in currencies"
      >{{ cur.name }}&nbsp;{{ cur.symbol }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from "vuex";

  export default {
    name: "CurrencySelect",
    computed: {
      ...mapState('mobile', [
        'currencies'
      ]),
      ...mapGetters('mobile', [
        'currency'
      ]),
    },
    methods: {
      ...mapActions('mobile', [
        'selectCurrency'
      ]),
    },
  }
</script>

<style lang="scss">
  .currency-select {
    .dropdown {
      width: 100%;
      text-align: right;
    }
  }

  .btn.btn-currency {
    color: #145aa0;
    font-size: 0.875em !important;
    line-height: 1.714285714285714em;
    border: 1px solid #145aa0;

    &:hover {
      color: #fff;
      background-color: #145aa0;
      border-color: #145aa0;
    }
  }
</style>
